import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { localeTimeParser } from 'helpers/destinationTimesParser';
import { StatusWrapper, Point, Title, StatusDate } from './FlightStatus.style';
import { Grid, Typography } from '@mui/material';

const Status = ({ list = false, statusInfo, operated }) => {
  const { t, i18n } = useTranslation();
  const { translation: english } = i18n.getDataByLanguage('en');

  const status = useMemo(() => {
    const enteries = Object.entries(english);
    let statusEntries;
    statusEntries = enteries.find(
      ([key, value]) =>
        key.includes('results.status') &&
        key
          .toLowerCase()
          .endsWith(
            statusInfo?.displayStatus?.toLowerCase()?.replaceAll(' ', '')

          ));
    if(!statusEntries) statusEntries = enteries.find(
      ([key, value]) =>
      key.includes('results.status') &&
      key
        .toLowerCase()
        .endsWith(
          statusInfo?.status?.toLowerCase()?.replaceAll(' ', '')

        ));
    if (statusEntries?.length === 2)
      return {
        value: statusEntries[1],
        key: statusEntries[0],
      };
    else return {};
  }, [english, statusInfo]);

  return (
    <StatusWrapper
      container
      alignItems="center"
      flexDirection="column"
      canceled={status?.value?.startsWith('C').toString()}
    >
      <Grid container>
        <Typography sx={{ fontSize: '14px', ml: '0' }}>
          {t('flightstatus.details.operated') + ` ${operated}`}
        </Typography>
      </Grid>
      <Grid container alignItems="center" flexWrap="nowrap">
        <Point color={statusInfo?.indicator} />
        <Title list={list.toString()} variant="p">
          {t(status?.key)}
        </Title>
        {statusInfo?.displayTime && (
          <StatusDate variant="p">
            {localeTimeParser(statusInfo.displayTime)}
          </StatusDate>
        )}
      </Grid>
    </StatusWrapper>
  );
};

export default Status;
